__turbopack_context__.v({
  "navigation": "qD8n8q_navigation",
});
